import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, CardHeader, CardBody, Progress, Badge } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";
import { formatXp, getMissionTypeLabel } from "./../../../helper/xpHelpers.js";
import moment from "moment";

class Missions extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    if (this.props.user && this.props.user.id) {
      await this.helper.gamification().getUserMissions(this.props.user.id);
    }
    this.setState({ loading: false });
  }

  render() {
    var missions = (this.props.gamification && this.props.gamification.missions) || [];
    var translate = this.props.translate || {};
    var active = missions.filter(function (m) { return !m.completed; });
    var completed = missions.filter(function (m) { return m.completed; });

    return (
      <React.Fragment>
        {!this.props.embedded && <SimpleHeader name="Missões" way={[{ name: "Conquistas", url: "/missions" }]} />}
        <Container className={this.props.embedded ? "mt-3" : "mt--6"} fluid>

          {/* Em andamento */}
          <Row>
            <Col xl="12">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">
                    <i className="fas fa-flag-checkered text-warning mr-2" />
                    Missões em Andamento
                    <Badge color="warning" pill className="ml-2">{active.length}</Badge>
                  </h3>
                </CardHeader>
                <CardBody>
                  {this.state.loading ? (
                    <div className="text-center py-3"><i className="fas fa-spinner fa-spin fa-2x text-muted" /></div>
                  ) : active.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="fas fa-inbox fa-3x mb-2" style={{ opacity: 0.3 }} />
                      <p className="text-muted">Nenhuma missão em andamento. Continue estudando!</p>
                    </div>
                  ) : (
                    <Row>
                      {active.map((m) => (
                        <Col md="6" lg="4" key={m.mission} className="mb-3">
                          <div style={{
                            border: '2px solid ' + (m.color || '#FF9800'),
                            borderRadius: '10px',
                            padding: '15px',
                            background: 'linear-gradient(135deg, ' + (m.color || '#FF9800') + '10 0%, transparent 100%)'
                          }}>
                            <div className="d-flex align-items-center mb-2">
                              <i className={(m.icon || 'fas fa-flag-checkered') + ' fa-2x mr-3'} style={{ color: m.color || '#FF9800' }} />
                              <div className="flex-grow-1">
                                <h5 className="mb-0">{m.name}</h5>
                                <small className="text-muted">{m.description}</small>
                              </div>
                            </div>
                            <Progress
                              value={m.percentComplete}
                              style={{ height: '10px' }}
                              barStyle={{ backgroundColor: m.color || '#FF9800' }}
                            />
                            <div className="d-flex justify-content-between mt-2">
                              <small><strong>{m.currentValue || 0}</strong> / {m.target} {getMissionTypeLabel(m.type)}</small>
                              <small className="text-success"><i className="fas fa-bolt mr-1" />+{formatXp(m.xpReward)} XP</small>
                            </div>
                            {m.endDate && (
                              <small className="text-muted d-block mt-2">
                                <i className="fas fa-clock mr-1" />
                                Termina em {moment(m.endDate).format('DD/MM/YYYY')}
                              </small>
                            )}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Concluídas */}
          {completed.length > 0 && (
            <Row className="mt-4">
              <Col xl="12">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <h3 className="mb-0">
                      <i className="fas fa-check-circle text-success mr-2" />
                      Missões Concluídas
                      <Badge color="success" pill className="ml-2">{completed.length}</Badge>
                    </h3>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      {completed.map((m) => (
                        <Col md="6" lg="4" key={m.mission} className="mb-3">
                          <div style={{
                            border: '2px solid #28a745',
                            borderRadius: '10px',
                            padding: '15px',
                            background: '#28a74510',
                            opacity: 0.85
                          }}>
                            <div className="d-flex align-items-center">
                              <i className="fas fa-check-circle fa-2x mr-3" style={{ color: '#28a745' }} />
                              <div>
                                <h6 className="mb-0">{m.name}</h6>
                                <small className="text-success">+{formatXp(m.xpReward)} XP recebido</small>
                              </div>
                            </div>
                            {m.completedDate && (
                              <small className="text-muted d-block mt-2">
                                Concluída em {moment(m.completedDate).format('DD/MM/YYYY')}
                              </small>
                            )}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  user: state.user,
  gamification: state.gamification,
  translate: state.translate
}))(Missions);
